/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import store from 'store'
import queryString from 'qs'
import isEmpty from 'lodash/isEmpty'
import { Helmet } from 'react-helmet'
import { Custom } from 'utils/displayResponsive'
import getImageUrl from 'utils/getImageUrl'
import {
  Container,
  Content,
  Cover,
  CoverImage,
  BackContainer,
  Detail,
  DetailContent1,
  DetailContent3,
  CourseNameContainer,
} from './style'
import VideoCourse from './VideoCourse'
import EnrollSection from './EnrollSection'
import Description from './Description'
import Summary from './Summary'
import Instructor from './Instructor'
import Rating from './Rating'
import Category from './Category'
import Share from './Share'
import TabSection from './TabSection'
import ModalLogin from 'components/modalLogin'
import backIcon from 'images/back-white.svg'
import Typography from 'components/typography'
import styled from 'styled-components'
import Button from 'components/button'
import EnrollModal from 'components/enrollModal'
import CheckCircle from './CheckCircle.svg'
import { useWindowSize } from 'react-use'
import { getPrice } from 'utils/utils'
import purchasedIcon from '../../images/purchased-white.svg'

// import ScholoMarketplaceDesktop from 'components/schoolMarketplaceComponents/schoolMarketplaceResponsive/schoolMarketplaceDesktop'

const DetailContent2 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px 20px 0px 20px;

  @media (max-width: 720px) {
    padding: 0 30px 0 30px;
  }
  @media (max-width: 425px) {
    padding: 0 20px 0 20px;
  }
`
const RatingAndShare = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 35px;
  gap: 20px;

  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-start;
  }
  @media (max-width: 720px) {
    flex-direction: row;
    justify-content: space-between;
  }
  @media (max-width: 425px) {
    margin-bottom: 15px;
  }
  @media (max-width: 300px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`

const PriceGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;

  @media (max-width: 425px) {
    margin-top: 0px;
  }
`

const Tag = styled((props) => <Button {...props} />)`
  border: 1px solid #fff;
  color: #3d4453;
  border-radius: 4.125px;
  height: 25px;
  padding: 6px, 8px, 6px, 8px;

  background-color: #ebf4f9;
  cursor: default;
  width: 130px;
`
const PurchasedRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-end;
`
const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-bottom: 2px;
`

const Price = ({ enrolledStatus, totalPrice, locale, isFooter }) => {
  const isTh = locale === 'th'
  const { width } = useWindowSize()
  const displayPrice = (price) => {
    if (price === 0) {
      return isTh ? 'ฟรี' : 'Free'
    }
    if (price > 0) {
      return getPrice(price)
    }
    return isTh ? 'ใช้โค้ดเท่านั้น' : 'Use Code Only'
  }

  return (
    <Fragment>
      {enrolledStatus === 'enrolled' ? (
        <PurchasedRow>
          <Typography
            id="course.detail.purchased"
            color={isFooter ? 'primary1' : 'white'}
            fontSize={width <= 425 ? 'text-sm' : 'text-xl'}
            fontWeight={width <= 425 ? 700 : 600}
            nowrap
          >
            Purchased
          </Typography>
          <Icon src={purchasedIcon} alt="purchasedIcon" />
        </PurchasedRow>
      ) : (
        <Typography
          color={isFooter ? 'primary1' : 'white'}
          fontSize={width <= 425 ? 'text-sm' : 'text-xl'}
          fontWeight={width <= 425 ? 700 : 600}
          nowrap
        >
          {displayPrice(totalPrice)}
        </Typography>
      )}
    </Fragment>
  )
}

const CourseDetail = (props) => {
  // console.log('props', props)
  const {
    match,
    history,
    location,
    getCourseBySlug,
    course,
    appUser,
    checkPrerequisite,
    prerequisiteResult,
    promotion,
    enrollCourse,
    checkInvitationLink,
    error,
    locale,
    enrolledStatus,
    numberOfStudents,
    lectures,
    getCourseStudentNumber,
    getCourseCertificates,
    courseCertificates,
    // Confirm,
  } = props
  const { courseSlug } = match?.params
  const isTh = locale === 'th'
  const qsValues = queryString.parse(location.search, { ignoreQueryPrefix: true })
  const inviteCode = qsValues?.inviteCode
  const mobile = window.matchMedia(`(max-width: 768px)`)
  const maxHeight = window.matchMedia(`(max-height: 768px)`)
  const [isLoading, setIsLoading] = useState(true)
  const [hasVideo, setHasVideo] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)

  const packagePrice = course?.packagePrice || []
  const [quantity] = useState({ value: 1, label: 1 })
  const totalPrice =
    packagePrice.length > 0
      ? packagePrice.find((item) => item.quantity === quantity.value)?.price
      : course?.price

  // const quantityOptions = packagePrice.map((item) => {
  //   if (isTh)
  //     return { label: `ลงทะเบียน 1 ครั้ง เรียนได้ ${item.quantity} ท่าน`, value: item.quantity }

  //   return {
  //     label: `1 Registration for ${item.quantity} Accounts`,
  //     value: item.quantity,
  //   }
  // })
  const Div = styled.div`
    padding: 40px 24px 33px 24px;
    p + p {
      margin: 0px 0px 50px 0px;
    }
    @media (min-width: 426px) {
      div {
        display: flex;
        justify-content: space-evenly;
      }
    }
    @media (max-width: 425px) {
      padding: 12px 28px 24px 28px;
      p + p {
        margin-bottom: 24px;
      }
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        button {
          width: 232px;
        }
      }
    }
  `
  const routeLocation = {
    pathname: '/user/login',
    state: { from: location },
  }

  useEffect(() => {
    getCourseBySlug(courseSlug).finally(() => setIsLoading(false))
  }, [])

  useEffect(() => {
    const courseId = course?.id
    if (!courseId) {
      return
    }

    setHasVideo(Boolean(course?.introVideo))
    checkPrerequisite({ courseId })
    getCourseStudentNumber({ courseId })
    getCourseCertificates({ courseId })
  }, [course])

  useEffect(() => {
    checkPrerequisite({ courseId: course?.id })
  }, [openModal, checkPrerequisite, course])

  const onEnroll = async ({ quantity = 1, promoCode, newPrice } = { quantity: 1 }) => {
    const courseId = course?.id
    const courseMode = course?.publicMode

    const checkCode = async () => {
      try {
        const result = await checkInvitationLink({ courseId, code: inviteCode })
        return result
      } catch (e) {
        throw e
      }
    }

    if (!isEmpty(appUser)) {
      try {
        const isFree = course?.price === 0 || newPrice === 0
        if (courseMode === 'PUBLIC') {
          //console.log('line 90')

          // PUBLIC course
          if (isFree) {
            //console.log('line 92')
            // FREE course
            await enrollCourse({
              courseId,
              isFree: true,
              promoCode,
              quantity,
            })
            // history.push(`/courses/${courseId}/checkout`)
            // Confirm.open({
            //   title: locale === 'th' ? 'ลงทะเบียนสำเร็จ' : 'Enrollment Complete',
            //   subtitle:
            //     locale === 'th'
            //       ? `คุณได้ลงทะเบียน ${course.name} สำเร็จแล้ว`
            //       : `You have successfully enrolled ${course.name}`,
            //   confirmText: locale === 'th' ? 'เริ่มเรียนทันที' : 'Go to course',
            //   cancelText: locale === 'th' ? 'ค้นหาคอร์สอื่นเพิ่มเติม' : 'Browse more course',
            //   onConfirm: () => {
            //     history.push(`/my-course/courses/${course.id}`)
            //     Confirm.close()
            //   },
            //   onCancel: () => {
            //     history.push('/browse/courses')
            //     Confirm.close()
            //   },
            // })
            setIsOpenModal(true)
          } else {
            // PAID course
            const qs = queryString.stringify({ quantity, promoCode })
            history.push(`/courses/${courseId}/checkout?${qs}`)
          }
        } else if (courseMode === 'CODE') {
          //console.log('line 109')
          // PRIVATE course
          if (!inviteCode || inviteCode === '')
            error({
              title: isTh ? 'ต้องมีรหัสเชิญเพื่อลงทะเบียน' : 'Invitation code required to enroll',
            })
          else if (isFree) {
            // FREE course
            await enrollCourse({
              courseId,
              isFree: true,
              invitedCode: inviteCode,
            })
            await getCourseBySlug(courseSlug)
          } else {
            // PAID course
            const { isValid: isCodeValid } = await checkCode()
            if (!isCodeValid) {
              error({ title: isTh ? 'รหัสเชิญไม่ถูกต้อง' : 'This code is invalid.' })
            } else if (isCodeValid) {
              const qs = queryString.stringify({ invitedCode: inviteCode })
              history.push(`/courses/${courseId}/checkout?${qs}`)
            }
          }
        }
      } catch (e) {
        throw e
      }
    }
    return true
  }

  const handleLoginModal = () => {
    setOpenModal(true)
  }

  const EnrollSectionProps = {
    course,
    isLoading,
    inviteCode,
    enrolledStatus,
    prerequisiteResult,
    promotion,
    locale,
    onEnroll,
    handleLoginModal,
  }

  const SummaryProps = {
    course,
    numberOfStudents,
    lectures,
    locale,
  }

  const TabSectionProps = {
    course,
    certificates: courseCertificates,
    lectures,
    locale,
  }
  const PriceProps = {
    enrolledStatus: enrolledStatus,
    totalPrice,
    locale: locale,
  }
  console.log('TabSectionProps', TabSectionProps)
  return (
    <Container>
      <Helmet>
        <meta
          property="og:url"
          content={`${window.location.protocol}//${window.location.host}${props.location.pathname}`}
        />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={course?.name} />
        <meta property="og:description" content={course?.shortDescription} />
        <meta property="og:image" content={getImageUrl(course.image)} />
      </Helmet>
      <Content>
        <BackContainer onClick={() => history.push('/browse/courses')}>
          <img src={backIcon} alt="back" width={13} height={28} style={{ paddingRight: 3 }} />
        </BackContainer>
        <Cover>
          {hasVideo ? (
            <VideoCourse />
          ) : (
            <CoverImage
              src={getImageUrl(
                course?.image,
                'https://via.placeholder.com/300/FFFFFF/FFFFFF',
                3000,
                3000
              )}
            />
          )}
        </Cover>
        <CourseNameContainer>
          <Typography color="primary1" fontSize="text-xl" bold>
            {course?.name}
          </Typography>
        </CourseNameContainer>
        <Detail>
          <DetailContent1>
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: '30px' }}>
              <div style={{ display: 'flex', gap: 10 }}>
                <Tag nowrap fontSize={'12px'} fontWeight={400} lineHeight="20px">
                  <Typography
                    styled={{ color: '#253E87', fontSize: '12px' }}
                    lineHeight={'20px'}
                    fontWeight={400}
                    color="primary1"
                  >
                    {course?.mainCategory?.name}
                  </Typography>
                </Tag>
                <Tag nowrap fontSize={'12px'} fontWeight={400} lineHeight="20px">
                  <Typography
                    styled={{ color: '#253E87', fontSize: '12px' }}
                    lineHeight={'20px'}
                    fontWeight={400}
                    color="primary1"
                  >
                    {course?.subCategory?.name}
                  </Typography>
                </Tag>
              </div>
              <div style={{ display: 'flex' }}>
                <div style={{ flex: 0.5 }}>
                  <Instructor course={course} textHeding={'Instructor'} />
                </div>
                <div style={{ flex: 1 }}>
                  <Instructor course={course} textHeding={'Academy'} />
                </div>
              </div>

              <Description name={course?.name} description={course?.description} />
            </div>
          </DetailContent1>
          <DetailContent2>
            <PriceGroup>
              <Typography
                id="course.detail.tuitionFee"
                color="primary1"
                fontSize={16}
                fontWeight={600}
              >
                Tuition Fee
              </Typography>
              <Price {...PriceProps} isFooter />
            </PriceGroup>
            <RatingAndShare>
              <Rating rating={course?.avgRating} disabledTagProps />
              <Share courseSlug={courseSlug} locale={locale} />
            </RatingAndShare>

            <EnrollSection {...EnrollSectionProps} />
            <Summary {...SummaryProps} fontSize={12} />
          </DetailContent2>
        </Detail>
      </Content>
      <div style={{ margin: 12 }} />
      <Content>
        <div style={{ marginTop: 20 }} />
        <DetailContent3>
          <TabSection {...TabSectionProps} />
          <Custom maxWidth={720}>
            <Summary {...SummaryProps} />
          </Custom>
          <Custom maxWidth={720}>
            <Category course={course} />
          </Custom>
        </DetailContent3>
      </Content>
      <div style={{ margin: 50 }} />

      <ModalLogin
        isOpen={openModal}
        setOpenModal={setOpenModal}
        location={routeLocation}
        isMobile={mobile}
        maxHeight={maxHeight}
        shownXclose
      />
      <EnrollModal
        isOpen={isOpenModal}
        onRequestClose={() => setIsOpenModal(false)}
        onClickClose={isOpenModal}
      >
        <img src={CheckCircle} alt="checkCircle" style={{ width: '200px' }} />
        <Div>
          <Typography
            id="checkout.enrollment"
            color="primary10"
            margin="0px 0px 15px 0px"
            fontWeight="600px"
          >
            Enrollment Complete
          </Typography>
          <Typography id="checkout.subtitle" color="black100" values={{ name: course.name }}>
            You have successfully enrolled {course.name}
          </Typography>
          <div>
            <Button
              color="primary1"
              cancelbtn
              onClick={() => {
                history.push('/browse/courses')
                setIsOpenModal(false)
              }}
            >
              <Typography id="enrollment.card.browseBtn" fontSize="text-base" color="primary1" bold>
                Browse more course
              </Typography>
            </Button>
            <Button
              confirmbtn
              onClick={() => {
                history.push(`/my-course/courses/${course.id}`)
                setIsOpenModal(false)
              }}
            >
              <Typography id="enrollment.card.courseBtn" fontSize="text-base" color="white" bold>
                Go to course
              </Typography>
            </Button>
          </div>
        </Div>
      </EnrollModal>
    </Container>
  )
}

const selection = store.select((models) => ({
  enrolledStatus: models.Course.enrolledStatus,
  lectures: models.Course.lectures,
}))
const mapState = (state) => {
  return {
    course: state.Course.courseDetail,
    numberOfStudents: state.Course.numberOfStudents,
    appUser: state.AppUser.appUser,
    promotion: state.Enrollment.promotion,
    prerequisiteResult: state.Enrollment.prerequisiteResult,
    courseCertificates: state.ProgramCertificate.courseCertificates,
    locale: state.Language.locale,
    ...selection(state),
  }
}
const mapDispatch = (dispatch) => {
  return {
    getCourseBySlug: dispatch.Course.getCourseBySlug,
    getCourseStudentNumber: dispatch.Course.getCourseStudentNumber,
    checkInvitationLink: dispatch.Course.checkInvitationLink,
    checkPrerequisite: dispatch.Enrollment.checkPrerequisite,
    enrollCourse: dispatch.Enrollment.enrollCourse,
    getCourseCertificates: dispatch.ProgramCertificate.getCourseCertificates,
    error: dispatch.Alert.error,
    Confirm: dispatch.Confirm,
  }
}

export default connect(mapState, mapDispatch)(CourseDetail)
